"use client";
import { PhoneFrame, QrCodeMark } from "@/components/marketing";

import { useQrSceneMotion } from "./hooks";

interface QrFlowSceneProps {
  ariaLabel: string;
  standLabel: string;
  badge: string;
  chip: string;
}

// Hero illustration (the preview's `qr_flow` visual), straight on the dark
// hero: a QR stand on the counter and a phone scanning it, with a scan line
// sweeping the code and a "Joined" badge popping in.
const QrFlowScene = ({
  ariaLabel,
  standLabel,
  badge,
  chip,
}: QrFlowSceneProps) => {
  const { scanRef, badgeRef } = useQrSceneMotion();

  return (
    <figure
      role="img"
      aria-label={ariaLabel}
      className="relative mx-auto m-0 grid w-full max-w-[460px] grid-cols-[minmax(0,1fr)_auto] items-end gap-5 pt-10 sm:gap-8"
    >
      <span className="absolute top-0 left-0 rounded-full bg-tone-lilac-ink px-3.5 py-1.5 text-[12.5px] font-bold text-white shadow-lift">
        {chip}
      </span>

      <div className="grid justify-items-center pb-2">
        <QrCodeMark
          size="lg"
          className="relative z-10 -mb-4 aspect-square w-[64%] shadow-lift"
        />
        <div className="relative w-full overflow-hidden rounded-2xl bg-white px-3 pt-8 pb-5 text-center shadow-lift">
          <span
            aria-hidden="true"
            className="absolute inset-x-0 top-0 h-3 bg-primary"
          />
          <b className="text-[13px] font-extrabold text-ink sm:text-sm">
            {standLabel}
          </b>
        </div>
      </div>

      <div className="w-[170px] sm:w-[220px]">
        <PhoneFrame contentClassName="grid content-center justify-items-center gap-5 px-4 pb-9">
          <div className="relative w-full rounded-xl border-2 border-dashed border-primary p-3">
            <QrCodeMark size="lg" className="aspect-square w-full p-0" />
            <span
              ref={scanRef}
              aria-hidden="true"
              className="absolute inset-x-2 top-2 h-[3px] rounded-full bg-primary"
            />
          </div>
          <span
            ref={badgeRef}
            className="rounded-full bg-primary px-6 py-2 text-sm font-bold text-white"
          >
            {badge}
          </span>
        </PhoneFrame>
      </div>
    </figure>
  );
};

export default QrFlowScene;
